import React, { useState } from "react";
import Like from "../../assets/icons/Like";
import NoLike from "../../assets/icons/NoLike";
import styles from './InstantFeedback.module.css'
import { t } from "../../lib/i18n";

const InstantFeedbackView = (props) => {
    const [selectedItem, setSelectedItem] = useState(null);

    const _handleSelectedItem= (event, item) => {
        event.stopPropagation()
        if (selectedItem && selectedItem.includes('like')) return;
        setSelectedItem((oldItem) => (oldItem === null ? item : oldItem !== item ? item : null))
        props.handleOnSelected({assessment: item})
    };

    return (
        <div className={`text-center ${styles.ifbk_main}`}>
            <div className="row justify-content-center">
                <div className="col-12 text-center">
                    <p className={styles.ifbk_text_center}>{t("Ajude-nos a melhorar sua experiência!")}</p>
                    <p className={styles.ifbk_text_center}><strong>{t("Como é sua experiência com o Catchup?")}</strong></p>
                </div>
                <div className="col-12">
                    <div className="d-flex justify-content-center">
                        <div className={`${selectedItem === 'like' ? styles.ifbk_choose_button_selected : styles.ifbk_choose_button_not_selected} ${styles.ifbk_choose_button}`} tabIndex="1"
                            onClick={(e) => _handleSelectedItem(e, 'like')}>
                            <Like className={styles.ifbk_icon} />
                            <span>{t("BOM")}</span>
                        </div>
                        <div className={`${selectedItem === 'no-like' ? styles.ifbk_choose_button_selected : styles.ifbk_choose_button_not_selected} ${styles.ifbk_choose_button}`} tabIndex="1"
                            onClick={(e) => _handleSelectedItem(e, 'no-like')}>
                            <NoLike className={styles.ifbk_icon} />
                            <span>{t("RUIM")}</span>
                        </div>
                    </div>
                </div>
                <div className="col-12 text-center">
                    {selectedItem
                        ? <p>{t("Obrigado por avaliar!")}</p>
                        : <p>&nbsp;</p>
                    }
                </div>
            </div>
        </div>
    );
};

export default InstantFeedbackView;
